import PropTypes from 'prop-types';
import RatedTableIcons from 'components/icons/landing/rated-table-icons';
import styles from 'styles/LandingComponents.module.scss';

/**
 * # RateOptionHeader
 * Component that return a header with a label and an Icon.
 *
 * @component RateOptionHeader
 * @param {string} label - Header label.
 * @param {number} gap - Gap between items
 * @param {("diamond"|"shield"|"checked-shield"|"smile-face"|"cheapest-price"|"avg-price"|"maximum-price")} icon - String value with the name of the desired icon
 * @param {string} width - String Size
 * @returns
 */
const RateOptionHeader = ({ gap, label, icon, width }) => {
    return (
        <div
            style={{ gap }}
            className={`${styles.landing__rated_options_header_wrapper}`}
        >
            <RatedTableIcons icon={icon} width={width} />
            {label ? <p>{label}</p> : null}
        </div>
    );
};

RateOptionHeader.propTypes = {
    icon: PropTypes.string.isRequired,
    gap: PropTypes.number,
    label: PropTypes.string.isRequired,
    width: PropTypes.number
};

export default RateOptionHeader;
